import styled from "styled-components";
import {
  colors,
  spacings,
  borders,
  fontSizes,
  fontWeights,
} from '../../../styles/theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacings.lg};
  padding-bottom: ${spacings.xl};
`

export const Section = styled.div`
  background: ${colors.white};
  padding: ${spacings.ls};
  border-radius: ${borders.lg};
`

export const FieldGrid = styled.dl`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-gap: ${spacings.lg};
  margin: 0;

  dt {
    font-size: ${fontSizes.xs};
    font-weight: ${fontWeights.w700};
    color: ${colors.neutral_darker};
    margin-bottom: 4px;
  }

  dd {
    margin: 0;
    font-size: ${fontSizes.sm};
    color: ${colors.neutral_darkest};
    word-break: break-word;
  }

  dd.missing {
    color: ${colors.neutral_darker};
    font-style: italic;
  }
`
